import axios from "../../../axios";

export const statusRefresh = async (ids) => {
  try {
    let { data } = await axios.get(`/v1/worker/status?worker_ids=${ids}`);
    return data;
  } catch (e) {
    console.log("error while getting workers", e);
    return false;
  }
};
